class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '')
      return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);

class MegaMenu extends HTMLElement {
  constructor() {
    super();

    this.parent = this.closest('li');
    this.trigger = this.querySelector('button');
    this.overlay = this.querySelector('.mega-menu__overlay');
    this.wrapper = this.querySelector('.mega-menu__main-container-wrapper');
    this.touch = document.documentElement.classList.contains('touch');

    // close the mega menu when the user focuses a different menu item
    document.querySelectorAll('.header__menu-item').forEach((link) => {
      if (link !== this.trigger) {
        link.addEventListener('focusin', () => {
          this.closeAllMegaMenus();
        });
      }
    });

    // listen for a click outside the wrapper so touch devices can also close the menu by clicking on the overlay
    this.overlay.addEventListener('click', (event) => {
      if (!this.touch) return;
      if (event.target.closest('.mega-menu__main-container-wrapper')) return;

      this.closeAllMegaMenus(true);
    });

    // listen for mouse moving outside the wrapper so for non-touch devices the menu closes automatically
    this.wrapper.addEventListener('mouseleave', () => {
      if (this.touch) return;

      this.closeAllMegaMenus();
    });

    // only hover on desktop
    this.parent.addEventListener('mouseenter', (event) => {
      // mouseenter will also fire on touch devices, so if this is a touch device, return. For touch devices we listen for click events.
      if (this.touch) return;

      event.stopPropagation();

      this.hover = true;
      this.openMegaMenu();
    });

    // touch and keyboard
    this.trigger.addEventListener('click', (event) => {
      event.stopPropagation();

      if (this.expanded && this.trigger.dataset.url) {
        window.location.href = this.trigger.dataset.url;
      } else {
        this.hover = false;
        this.openMegaMenu();
      }
    });
  }

  handleKeyDownEvents(event) {
    if (!event.code) return;

    event.code === 'Escape' && this.closeAllMegaMenus();
  }

  openMegaMenu() {
    this.overlay.classList.add('open');
    this.trigger.ariaExpanded = true;
    this.expanded = true;

    if (this.hover) {
      this.parent.addEventListener('mouseleave', this.closeMegaMenu.bind(this), { once: true });
    } else {
      trapFocus(this.overlay);
    }
  }

  closeMegaMenu() {
    this.overlay.classList.remove('open');
    this.trigger.ariaExpanded = false;
    this.expanded = false;

    if (this.hover) {
      this.parent.removeEventListener('mouseleave', this.closeMegaMenu.bind(this), { once: true });
    } else {
      removeTrapFocus(this.trigger);
    }
  }

  closeAllMegaMenus(closeOverlay = false) {
    if (!closeOverlay && !document.querySelector('.mega-menu__overlay.open')) return;

    document.querySelectorAll('.mega-menu__overlay').forEach((overlay) => {
      overlay.classList.remove('open');
      overlay.previousElementSibling.ariaExpanded = false;
      this.expanded = false;
    });
  }
}
if (!customElements.get('mega-menu')) {
  // Listen for the escape key
  window.addEventListener('keydown', (event) =>
    document.querySelectorAll('mega-menu')[0].handleKeyDownEvents(event)
  );

  customElements.define('mega-menu', MegaMenu);
}
